import React from 'react'
import SinglePage from '../../views/SinglePage'

import { getWpTermspage } from '../../data/privacy'

export default function termsOfUse (props) {
  const fullArticle = props.wp.page

  return (
    <React.Fragment>
      <SinglePage
        title={fullArticle.title.rendered}
        slug={fullArticle.slug}
        body={fullArticle.excerpt.rendered}
        content={fullArticle.content.rendered}
      />
    </React.Fragment>
  )
}

export async function getStaticProps ({ preview = false }) {
  const wp = {
    ...(await getWpTermspage())
  }

  return {
    props: {
      wp
    }
  }
}
